import { Injectable } from '@angular/core';
import {
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { B2BUserRole } from '@spartacus/core';
import { FormService } from '@spartacus/organization/administration/components';
import { CustomFormValidators } from '@spartacus/storefront';
import { UigUserForm } from '../../uig-user/uig-user.model';

@Injectable({
  providedIn: 'root'
})
export class UigUserFormService extends FormService<UigUserForm> {

  protected build() {
    const form = new UntypedFormGroup({});
    form.setControl('customerId', new UntypedFormControl(''));
    form.setControl('titleCode', new UntypedFormControl(''));
    form.setControl('firstName', new UntypedFormControl('', Validators.required));
    form.setControl('lastName', new UntypedFormControl('', Validators.required));
    form.setControl('email', new UntypedFormControl('', [Validators.required, CustomFormValidators.emailValidator]));
    form.setControl('shippingAddressPk', new UntypedFormControl('', Validators.required));
    form.setControl('preferredDeliveryModeCode', new UntypedFormControl('', Validators.required));
    form.setControl('suiGenerisPermission', new UntypedFormGroup({ uid: new UntypedFormControl(undefined) }));
    form.setControl('orgUnit', new UntypedFormGroup({ uid: new UntypedFormControl(undefined) }));
    form.setControl('roles', new UntypedFormArray([]));
    form.setControl('isAssignedToApprovers', new UntypedFormControl(false));
    form.setControl('uid',new UntypedFormControl('', Validators.required));
    form.setControl('edit',new UntypedFormControl(''));

    form.get('roles').valueChanges.subscribe((roles: string[]) => {
      if (roles.includes(B2BUserRole.APPROVER)) {
        form.get('isAssignedToApprovers').enable();
      } else {
        form.get('isAssignedToApprovers').disable();
        form.get('isAssignedToApprovers').reset();
      }
    });

    this.form = form;
  }

  protected patchData(item: UigUserForm) {
    super.patchData(item);
    if (item) {
      const roles = this.form.get('roles') as UntypedFormArray;
      item.roles?.forEach((role) => {
        if (!(roles.value as string[]).includes(role)) {
          roles.push(new UntypedFormControl(role));
        }
      });
    }
  }

  getForm(item?: UigUserForm): UntypedFormGroup {
    if (this.form && !!item) {
      this.patchData(item);
      return this.form;
    }

    if (!this.form) {
      this.build();
    }

    // while we should be able to reset with initial value, this doesn't always work
    // hence, we're patching afterwards.
    this.form.reset();

    this.form.enable();
    this.patchData(item);

    return this.form;
  }
}
